<div class="overflow-x-auto rounded-lg border border-base-content/20">
  <table class="table table-zebra table-sm static">
    <thead>
      <tr>
        @if (invoices[0].desktop_invoice.completed) {
          <td>Completed At</td>
        }
        <td>Total Amount</td>
        <td
          class="cursor-pointer"
          (click)="sortChanged.emit('desktop_invoice.created_at')"
        >
          <span>Created Date</span>
          @if (currentSort?.field === 'desktop_invoice.created_at') {
            @if (currentSort?.direction === 'ASC') {
              <app-chevron-up-icon
                class="absolute inline-block h-6 w-6"
              ></app-chevron-up-icon>
            } @else {
              <app-chevron-down-icon
                class="absolute inline-block h-6 w-6"
              ></app-chevron-down-icon>
            }
          }
        </td>
        <td>Note</td>
        @if (showDeleteButton) {
          <td class="w-10"></td>
        }
        @if (showStatusButton) {
          <td>Status</td>
          <td></td>
        }
      </tr>
    </thead>
    <tbody>
      @for (invoice of invoices; track invoice) {
        <tr
          class="cursor-pointer"
          (click)="
            browseToInvoice(
              invoice.desktop_invoice.id,
              invoice.desktop_invoice.tenant_id
            )
          "
        >
          @if (invoice.desktop_invoice.completed) {
            <td>
              {{
                invoice.desktop_invoice.completed_at
                  | date: 'MM/dd/yyyy, hh:mmaa'
              }}
            </td>
          }
          <td>
            {{ invoice.desktop_invoice.total_amount | currency }}
          </td>
          <td>
            {{
              invoice.desktop_invoice.created_at | date: 'MM/dd/yyyy, hh:mmaa'
            }}
          </td>
          <td
            class="max-w-[14rem] truncate"
            [title]="invoice.desktop_invoice.notes || ''"
          >
            {{ invoice.desktop_invoice.notes || '—' }}
          </td>
          @if (showDeleteButton) {
            <td class="w-10">
              <div
                class="h-6 w-6 text-error hover:text-error/80"
                (click)="deleteInvoice($event, invoice)"
              >
                <app-trash-icon></app-trash-icon>
              </div>
              <!-- <button
                class="btn btn-error btn-sm"
                (click)="deleteInvoice($event, invoice)"
              >
                <app-trash-icon></app-trash-icon>
              </button> -->
            </td>
          }
          @if (showStatusButton) {
            <td>
              {{ invoice.desktop_invoice.status || 'completed' | titlecase }}
            </td>
            <td class="w-24">
              <div
                class="h-6 w-6 cursor-pointer hover:text-base-content/80"
                (click)="changeStatus($event, invoice)"
              >
                <app-edit-icon></app-edit-icon>
              </div>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
